import { NavLink, Route, Routes } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import ReleasesPage from './pages/ReleasesPage';
import CommandsPage from './pages/CommandsPage';
import AccessControlPage from './pages/AccessControlPage';
import BuildRunsPage from './pages/BuildRunsPage';

export default function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-title">Tennative Support</span>
        <nav className="app-nav">
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/releases">Releases</NavLink>
          <NavLink to="/commands">Commands</NavLink>
          <NavLink to="/access">Access Control</NavLink>
          <NavLink to="/runs">Build Runs</NavLink>
        </nav>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/releases" element={<ReleasesPage />} />
          <Route path="/commands" element={<CommandsPage />} />
          <Route path="/access" element={<AccessControlPage />} />
          <Route path="/runs" element={<BuildRunsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
}
